<template>
  <v-row class="justify-center" transition="slide-x-transition">
    <v-col
      cols="10"
      sm="12"
      md="10"
      lg="10"
      class="d-flex align-stretch pa-1"
      v-if="selected==null"
    >
      <v-card class="flex-grow-1">
        <v-toolbar color="grey lighten-4" elevation="0" light dense>
          <v-toolbar-title>Meus Planos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$router.go(-1)">
            <v-icon>fa-solid fa-reply</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- <v-card-subtitle v-if="hasExpiredSlip" class="title text-left primary--text"><v-icon color="primary">fa-solid fa-triangle-exclamation</v-icon> José Silva, Você possui boletos vencidos!</v-card-subtitle> -->
        <v-card-text class="text--primary mb-6 justify-center">
          <p v-if="showAlertPayment" class="text-left primary--text">
            <v-icon small color="primary">fa-solid fa-triangle-exclamation</v-icon>
            {{userName}}, você possui boletos vencidos!
          </p>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Nome do Plano</th>
                  <th class="text-left">Operadora</th>
                  <th class="text-left">Vencimento</th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in plans" :key="item.contrato.id">
                  <td class="text-left">{{ item.contrato.plano }}</td>
                  <td class="text-left">{{ item.contrato.operadorafantasia }}</td>
                  <td class="text-left primary--text" v-if="hasExpiredSlip(item.fichafinanceira)">
                    <v-icon small color="primary">fa-solid fa-triangle-exclamation</v-icon>Você possui boletos vencidos!
                  </td>
                  <td class="text-left" v-else>
                    <span
                      v-if="getVcto(item.fichafinanceira) == 'Você não possui boletos em aberto' "
                    >{{ getVcto(item.fichafinanceira) }}</span>
                    <span v-else>{{ getVcto(item.fichafinanceira) | moment("DD/MM/YYYY") }}</span>
                  </td>
                  <td class="text-left">
                    <v-btn text icon color="secondary darken-4" @click="selected = item">
                      <v-icon>fa-regular fa-eye</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-col>
    <detailsPlan
      :plan="selected"
      v-if="selected!=null"
      :close="dismissModal"
      :userName="userName"
      :openedBankSlip="(bankSlipList)=>getOpened(bankSlipList)"
      :hasExpiredSlip="hasExpiredSlip(selected.fichafinanceira)"
      :wasExpired="(dt) => wasExpired(dt)"
    />
  </v-row>
</template>

<script>
import detailsPlan from "./details";
export default {
  components: {
    detailsPlan,
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    plans() {
      return this.$store.state.plans.plans;
    },
    showAlertPayment() {
      let isToShow = this.$store.dispatch(
        "bankSlip/showAlertPayment",
        this.plans
      ).length;
      return isToShow;
    },
    userName() {
      return this.$store.state.plans.userName;
    },
  },
  mounted() {
    this.$store.commit("toggleMenu", "show");
  },
  methods: {
    dismissModal() {
      this.selected = null;
    },
    async getOpened(paymentList) {
      console.log('sss')
      let listByPlan = paymentList.filter(this.onlyOpened);
      let listWithDigiline = [];
      await this.$store
        .dispatch("bankSlip/getDigiline", listByPlan)
        .then((newList) => {
          listWithDigiline = newList;
          return listWithDigiline;
        });
      return listWithDigiline;
    },
    getVcto(fichafinanceira) {
      let hasOpened = fichafinanceira.filter(this.onlyOpened);
      if (!hasOpened.length) {
        return "Você não possui boletos em aberto";
      }
      return hasOpened[0].datavencimento;
    },
    hasExpiredSlip(fichafinanceira) {
      if (fichafinanceira == null) {
        return true;
      }
      let hasExpired = fichafinanceira
        .filter(this.onlyOpened)
        .findIndex(this.wasExpired);
      return hasExpired > -1;
    },
    onlyOpened: (bankSlip) => bankSlip.situacao != "Pago",
    wasExpired: (bankSlip) =>
      new Date(bankSlip.datavencimento).getTime() < new Date().getTime(),
  },
};
</script>

<style>
</style>